(function () {
  'use strict';

  angular
  .module('directive.stop-propagation', [])

  /* @ngInject */
  .directive('stopPropagation', function () {
    return {
      restrict: 'A',
      link: function (scope, element) {

        element.click(function (event) {
          event.stopPropagation();
          event.preventDefault();
        });
        scope.$on('$destroy', function () {
          element.off('click');
        });

      }
    };

  });

})();
